// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:47:07

export default {
  "id": "parking-jam-1",
  "slug": "parking-jam-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6a61538d55e34a46ac5cfa0fbdfd1cf5-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6a61538d55e34a46ac5cfa0fbdfd1cf5/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Parking Jam",
      "description": "Master the madness in Parking Jam - can you clear the lot without causing chaos? Parking Jam is a mind-bending puzzle game that puts your logic and problem-solving skills to the test! Your goal? Free the cars from a crowded parking lot, but there’s a catch—cars are blocking each other, and you need to move them in the correct order to avoid a jam. Each level brings a new parking lot puzzle, with increasing complexity as more cars and obstacles appear.",
      "instructions": "Click and slightly drag the cars in the direction you want them to get out of the parking lot. Clear the parking lot as efficient as possible.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1player",
        "3d",
        "car",
        "parking",
        "thinking"
      ]
    },
    "zh-CN": {
      "title": "停车拥堵",
      "description": "掌握混乱在停车拥堵中的技巧——你能在不引起混乱的情况下清理停车场吗？停车拥堵是一款考验你逻辑和解决问题的思维游戏！你的目标？从拥挤的停车场中释放汽车，但有一个条件——汽车彼此阻碍，你需要按正确的顺序移动它们以避免拥堵。每个关卡都带来一个新的停车场谜题，随着更多汽车和障碍物的出现，难度逐渐增加。",
      "instructions": "点击并轻微拖动汽车，使其朝您希望它们离开的方向移动。尽可能高效地清理停车场。",
      "genres": [
        "拼图"
      ],
      "tags": [
        "1玩家",
        "3D",
        "汽车",
        "停车",
        "思考"
      ]
    },
    "zh-TW": {
      "title": "停車擁擠",
      "description": "駕馭瘋狂，在停車混亂中脫穎而出——你能在不造成混亂的情況下清空停車場嗎？停車混亂是一款讓你邏輯和問題解決能力接受挑戰的異想天開謎題遊戲！你的目標是從擁擠的停車場中釋放車輛，但有一個問題——車輛互相阻擋，你需要將它們移動到正確的順序以避免交通阻塞。每個關卡都帶來一個新的停車場謎題，隨著車輛和障礙物數量的增加，複雜性也隨之升高。",
      "instructions": "點擊並輕微拖動車輛，使其朝您希望的方向離開停車場。盡可能高效地清空停車場。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1玩家",
        "3D",
        "車",
        "停車",
        "思考"
      ]
    },
    "zh-HK": {
      "title": "停車擁擠",
      "description": "掌握停車混亂狂潮！你能清理停車場而不引起混亂嗎？停車混亂是一款令人著迷的益智遊戲，考驗你的邏輯和問題解決技巧！你的目標是從擁擠的停車場中釋放車輛，但有一個問題——車輛互相阻擋，你需要將它們移動到正確的順序以避免交通阻塞。每個關卡都帶來一個新的停車場謎題，隨著更多車輛和障礙物的出現，複雜性不斷增加。",
      "instructions": "點擊並輕微拖動汽車，將其推向您希望它離開停車場的方向。盡可能高效地清空停車場。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "3D",
        "車輛",
        "停車",
        "考慮"
      ]
    },
    "ja": {
      "title": "駐車場渋滞",
      "description": "パーキングジャムの狂気をマスターしよう！混雑した駐車場を無事に空けることができるか？パーキングジャムは、あなたの論理と問題解決スキルを試す心を奮い立たせるパズルゲームです！あなたの目標は、混雑した駐車場から車を解放することですが、問題があります－車がお互いに塞がれており、混雑を避けるために正しい順番で移動させる必要があります。各レベルで新しい駐車場のパズルが登場し、車や障害物が増えるにつれて難度も高まります。",
      "instructions": "駐車場から車を退場させたい方向にクリックし、少しドラッグしてください。駐車場をできるだけ効率的に空けるしてください。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "3D",
        "車",
        "駐車",
        "考える"
      ]
    },
    "ko": {
      "title": "주차 혼잡",
      "description": "파킹 잼에서 혼란을 통제하세요 - 혼잡한 주차장에서 혼란을 일으키지 않고 주차장을 비울 수 있을까요? 파킹 잼은 당신의 논리와 문제 해결 능력을 테스트하는 혼란스러운 퍼즐 게임입니다! 목표는 혼잡한 주차장에서 차량을 풀어내는 것입니다. 하지만 문제는 차량들이 서로 막고 있으며, 혼잡을 피하기 위해 올바른 순서로 이동시켜야 합니다. 각 레벨은 새로운 주차장 퍼즐을 제공하며, 차량과 장애물이 더 많아지면서 복잡성이 증가합니다.",
      "instructions": "주차장에서 차량을 나가고자 하는 방향으로 클릭하고 조금 내려 당겨주세요. 주차장을 최적의 효율성으로 청소하세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "3D",
        "자동차",
        "주차",
        "생각하고"
      ]
    },
    "fr": {
      "title": "Stationnement en panique",
      "description": "Maitrisez la folie dans Parking Jam - pouvez-vous libérer le parking sans provoquer le chaos ? Parking Jam est un jeu de puzzle captivant qui met votre logique et vos compétences en résolution de problèmes à l'épreuve ! Votre objectif ? Libérer les voitures d'un parking bondé, mais il y a un hic — les voitures se bloquent les unes les autres, et vous devez les déplacer dans l'ordre correct pour éviter un engorgement. Chaque niveau présente un nouveau puzzle de parking, avec une complexité croissante à mesure que plus de voitures et d'obstacles apparaissent.",
      "instructions": "Cliquez et faites glisser légèrement les voitures dans la direction où vous voulez qu'elles sortent du parking. Évacuez le parking aussi efficacement que possible.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "3D",
        "voiture",
        "stationnement",
        "réflexion"
      ]
    }
  }
};
